// extracted by mini-css-extract-plugin
module.exports = {"container":"Braintree_container__ZW2Ko"};